import RestService from '../services/rest';

const getAllLogs = async (tableParams) => RestService.postAuthenticated('logger/getGrid', tableParams);

export default {
  getAllLogs,
};
